import React, { useState, useEffect } from "react";
import data from "./data";
import btnIcon from "./images/icon-ellipsis.svg";

function App() {
  const [input, setInput] = useState(data);
  const [timelineValue, setTimelineValue] = useState(null);
  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setTimelineValue(value);
  };
  //console.log(timelineValue);
  const tile = input.map((item, index) => {
    if (timelineValue === "daily") {
      return (
        <div className={`${item.title}`} key={index}>
          <div className="svg">
            <img src={item.image} alt={item.title} />
          </div>

          <div className="innerContainer">
            <div className="heading">
              <h4>{item.title}</h4>
              <button className="btn">
                <img src={btnIcon} alt="btn" />
              </button>
            </div>
            <div className="time">
              <h1>{`${item.timeframes.daily.current}hrs`}</h1>
              <p>{`Last Daily = ${item.timeframes.daily.previous}hrs`}</p>
            </div>
          </div>
        </div>
      );
    } else if (timelineValue === "weekly") {
      return (
        <div className={`${item.title}`} key={index}>
          <div className="svg">
            <img src={item.image} alt={item.title} />
          </div>

          <div className="innerContainer">
            <div className="heading">
              <h4>{item.title}</h4>
              <button className="btn">
                <img src={btnIcon} alt="btn" />
              </button>
            </div>
            <div className="time">
              <h1>{`${item.timeframes.weekly.current}hrs`}</h1>
              <p>{`Last Daily = ${item.timeframes.weekly.previous}hrs`}</p>
            </div>
          </div>
        </div>
      );
    } else if (timelineValue === "monthly") {
      return (
        <div className={`${item.title}`} key={index}>
          <div className="svg">
            <img src={item.image} alt={item.title} />
          </div>

          <div className="innerContainer">
            <div className="heading">
              <h4>{item.title}</h4>
              <button className="btn">
                <img src={btnIcon} alt="btn" />
              </button>
            </div>
            <div className="time">
              <h1>{`${item.timeframes.monthly.current}hrs`}</h1>
              <p>{`Last Daily = ${item.timeframes.monthly.previous}hrs`}</p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={`${item.title}`} key={index}>
          <div className="svg">
            <img src={item.image} alt={item.title} />
          </div>

          <div className="innerContainer">
            <div className="heading">
              <h4>{item.title}</h4>
              <button className="btn">
                <img src={btnIcon} alt="btn" />
              </button>
            </div>
            <div className="time">
              <h1>{`${item.timeframes.weekly.current}hrs`}</h1>
              <p>{`Last Daily = ${item.timeframes.weekly.previous}hrs`}</p>
            </div>
          </div>
        </div>
      );
    }
  });
  return (
    <main className="main">
      <section className="container">
        <div className="profile">
          <img
            className="img"
            src={require("./images/image-jeremy.png")}
            alt="profile"
          />
          <div>
            <p className="name">Report for</p>
            <h1>Jeremy Roboson</h1>
          </div>
        </div>
        <div className="timeline">
          <button
            value="daily"
            style={{
              color:
                timelineValue === "daily"
                  ? "hsl(236, 100%, 87%)"
                  : "hsl(235, 45%, 61%)",
            }}
            onClick={handleChange}
          >
            daily
          </button>
          <button
            value="weekly"
            style={{
              color:
                timelineValue === null
                  ? "hsl(236, 100%, 87%)"
                  : timelineValue === "weekly"
                  ? "hsl(236, 100%, 87%)"
                  : "hsl(235, 45%, 61%)",
            }}
            onClick={handleChange}
          >
            weekly
          </button>
          <button
            value="monthly"
            style={{
              color:
                timelineValue === "monthly"
                  ? "hsl(236, 100%, 87%)"
                  : "hsl(235, 45%, 61%)",
            }}
            onClick={handleChange}
          >
            monthly
          </button>
        </div>
      </section>
      {tile}
    </main>
  );
}
export default App;
